import { render } from "./NoticeDetail.vue?vue&type=template&id=d614dcf4&scoped=true"
import script from "./NoticeDetail.vue?vue&type=script&lang=js"
export * from "./NoticeDetail.vue?vue&type=script&lang=js"

import "./NoticeDetail.vue?vue&type=style&index=0&id=d614dcf4&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d614dcf4"]])

export default __exports__